import { Box, TextField, Typography } from "@mui/material";
import ComercialInterfaceHeader from "@/components/comercial/ComercialInterfaceHeader";
import {sharedStyles} from "@/styles/shared";

export const BankingDataForm = ({ refs, accountType, setAccountType, pixKeyType, setPixKeyType }: any) => {
    return (
        <>
            <ComercialInterfaceHeader title="Dados Bancários e Gateway" />
            <Box sx={sharedStyles.verticalContent}>
                <TextField size="small" label="ID do Gateway" inputRef={refs.gatewayId} fullWidth />

                <Box sx={sharedStyles.dividedFormContainer}>
                    <TextField size="small" label="Banco (Código)" inputRef={refs.bank} fullWidth />
                    <TextField size="small" label="Agência" inputRef={refs.issuer} fullWidth />
                    <TextField size="small" label="Dígito Agência" inputRef={refs.issuerDigit} fullWidth />
                </Box>

                <Box sx={sharedStyles.dividedFormContainer}>
                    <TextField size="small" label="Número da Conta" inputRef={refs.accountNumber} fullWidth />
                    <TextField size="small" label="Dígito Conta" inputRef={refs.bankDigit} fullWidth />
                    <TextField
                        size="small"
                        select
                        label="Tipo de Conta"
                        value={accountType}
                        onChange={(e) => setAccountType(e.target.value)}
                        SelectProps={{ native: true }}
                        fullWidth
                        InputLabelProps={{ shrink: true }}
                    >
                        <option value="CHECKING_ACCOUNT">Conta Corrente</option>
                        <option value="SAVINGS_ACCOUNT">Conta Poupança</option>
                    </TextField>
                </Box>

                <Typography variant="subtitle2" sx={{ mt: 2, color: 'text.secondary' }}>
                    Configuração de Transferência (PIX)
                </Typography>

                <Box sx={sharedStyles.dividedFormContainer}>
                    <TextField
                        size="small"
                        select
                        label="Tipo de Chave PIX"
                        value={pixKeyType}
                        onChange={(e) => setPixKeyType(e.target.value)}
                        SelectProps={{ native: true }}
                        sx={{ width: "35%" }}
                        InputLabelProps={{ shrink: true }}
                    >
                        <option value="CPF">CPF</option>
                        <option value="CNPJ">CNPJ</option>
                        <option value="EMAIL">E-mail</option>
                        <option value="PHONE">Telefone</option>
                        <option value="RANDOM_KEY">Chave Aleatória</option>
                    </TextField>
                    <TextField size="small" label="Chave PIX" inputRef={refs.pixKey} sx={{ width: "65%" }} />
                </Box>
            </Box>
        </>
    );
};
